import { O_ID, StateEnum } from "../../defines";
import { bot_ball_dfa } from "./bot_ball_dfa";
import { bot_ball_dfj } from "./bot_ball_dfj";
import { bot_chasing_skill_action } from "./bot_chasing_skill_action";
import { BotMaker } from "./BotMaker";
import { frames } from "./frames";

export function make_bot_data_bat(): BotMaker {
  return new BotMaker(O_ID.Bat).set_actions(
    // laser_eyes
    bot_ball_dfa(25, void 0, 80),
    // fast_punch
    bot_ball_dfj(50, void 0, 0, 120),
    // bats
    bot_chasing_skill_action('d^j', void 0, 200, 0.05),
    // catching + fast_punch
    bot_chasing_skill_action('dva', void 0)
  ).set_states(
    [StateEnum.Catching],
    ['dva']
  ).set_frames([
    ...frames.standings,
    ...frames.walkings,
    ...frames.runnings
  ], ['d^j', 'd>j', 'd>a'])
}
BotMaker.register(O_ID.Bat, make_bot_data_bat)